function setFont () {
  var html = document.documentElement
  // var cHeight = html.clientHeight
  var cWidth = html.clientWidth
  html.style.fontSize = Math.min(cWidth / 750 * 100, 80) + 'px'
}
// export default function () {
setFont()
setTimeout(function () {
  setFont()
}, 300)
document.addEventListener('DOMContentLoaded', setFont, false)
window.addEventListener('resize', setFont, false)
window.addEventListener('load', setFont, false)
window.addEventListener('pageshow', setFont, false)
// }
